export default __webpack_public_path__ + "static/media/hrlogo_new.8818110d.png";